export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '91自拍论坛是什么？',
    answer: '91自拍论坛是一个专为摄影爱好者打造的自拍技巧交流平台。我们汇聚了海量的自拍教程、构图技巧、光线运用与后期修图经验分享，帮助每一位摄影爱好者提升自拍水平。无论你是刚入门的新手还是有一定基础的进阶玩家，都能在这里找到适合自己的学习内容。',
  },
  {
    question: '如何开始学习自拍技巧？',
    answer: '建议从构图基础开始学习，我们在"自拍构图"分类下有从三分法则入门到高级引导线构图的系统教程。掌握基础构图后，再逐步学习光线运用和后期修图。每个分类下的文章按照难度递进排列，方便你循序渐进地学习。',
  },
  {
    question: '论坛上的教程适合什么水平的摄影爱好者？',
    answer: '我们的教程覆盖从零基础到进阶的各个阶段。每个分类都有入门级教程和进阶内容，你可以在文章标签中看到难度标识。新手建议从带有"基础教程"标签的文章开始阅读，有一定基础的爱好者可以直接选择"进阶技巧"标签的文章。',
  },
  {
    question: '需要专业摄影设备吗？',
    answer: '完全不需要！91自拍论坛的核心理念就是用手机拍出好照片。我们绝大部分教程都以手机摄影为出发点，教你如何利用现有设备和环境条件拍出令人惊艳的自拍作品。当然，我们也提供一些性价比高的手机摄影配件推荐，帮助你在预算范围内获得更好的拍摄体验。',
  },
  {
    question: '如何加入91自拍论坛的社区？',
    answer: '你可以通过浏览我们的教程文章、在文章下方留言互动来参与社区交流。我们也定期举办线上自拍挑战赛和作品评选活动，欢迎关注首页公告了解最新活动信息。如果你想更深入地参与，可以通过"关于我们"页面的联系方式与我们取得联系。',
  },
  {
    question: '论坛上的内容可以转载吗？',
    answer: '91自拍论坛的所有原创内容均受版权保护。如果你希望转载我们的文章，请通过"关于我们"页面的联系方式与我们联系获取授权。我们鼓励知识分享，但请尊重原创作者的劳动成果，转载时务必注明出处和作者信息。',
  },
];